import GlobalStyles from '@mui/material/GlobalStyles';

/** Must stay in sync with @mui/material/InputBase inputGlobalStyles when disableInjectingGlobalStyles is enabled. */
export const muiInputBaseGlobalStyles = {
  '@keyframes mui-auto-fill': {
    from: {
      display: 'block',
    },
  },
  '@keyframes mui-auto-fill-cancel': {
    from: {
      display: 'block',
    },
  },
};

const MuiInputBaseGlobalStyles = () => <GlobalStyles styles={muiInputBaseGlobalStyles} />;

export default MuiInputBaseGlobalStyles;
